<template>
  <div v-observe-visibility="visibilityChanged">

    <v-dialog class="loading-dialog"
              v-model="creatingOffer"
              persistent
              overlay
              max-width="450px">
      <v-card>
        <v-layout row pt-4 pb-4 pr-4 pl-4>
          <v-flex xs12>
            <v-card-title class="headline">Creating Offer...</v-card-title>
          </v-flex>
          <v-flex justify-end>
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!--Add/Edit Position - Dialog-->
    <v-dialog v-model="addDialog" max-width="800px">
      <v-card>

        <v-card-title>
          <span v-if="getSelectedOfferPosition.id !== 0" class="headline">Edit Position</span>
          <span v-else class="headline">Add Position</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12 md8 pl-4 pa-2>
                <v-autocomplete
                  clearable
                  :items="getProducts"
                  label="Product-Reference"
                  v-model="getSelectedOfferPosition.products_id"
                  item-value="id"
                  item-text="reference"
                  :filter="referenceFilter"
                  :disabled="getSelectedOfferPosition.id !== 0"
                />
              </v-flex>


              <v-flex sm12 md4 pl-4 pa-2>
                <v-text-field :disabled="getSelectedOfferPosition.id !== 0"
                              label="Manufacturer"
                              :value="getManufacturerName(getSelectedOfferPosition.products_id)"
                              readonly
                />
              </v-flex>

              <v-flex sm12 md6 pl-4 pa-2 v-show="getSelectedOfferPosition.id === 0">
                <v-text-field
                  label="Quantity"
                  v-model="getSelectedOfferPosition.quantity"
                  type="number"
                  min="1"

                />
              </v-flex>

              <v-flex sm12 md6 pl-4 pa-2>
                <v-autocomplete
                  clearable
                  :items="getUnits"
                  label="Unit"
                  v-model="getSelectedOfferPosition.units_id"
                  item-value="id"
                  item-text="name"
                />
              </v-flex>

              <v-flex sm12 md6 pl-4 pa-2 v-show="getSelectedOfferPosition.id === 0">
                <v-text-field
                  suffix="%"
                  label="Margin"
                  v-model="getSelectedOfferPosition.margin"
                  type="number"
                  step=".01"
                  min="0.01"
                  max="1"
                />
              </v-flex>

              <v-flex sm12 md6 pl-4 pa-2>
                <v-autocomplete
                  clearable
                  :items="getVats"
                  label="VAT/Tax"
                  v-model="getSelectedOfferPosition.vats_id"
                  item-value="id"
                  item-text="name"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" flat @click.native="closeAddEditPositionDialog">Cancel</v-btn>
          <v-btn color="primary darken-1" flat @click.native="savePosition()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DELETE - Dialog-->
    <v-dialog
      persistent
      v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Position</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
            <v-checkbox
              :rules="[v => !!v || 'You have to check this to continue!']"
              required
              v-model="deleteChecked" color="primary"
              label="Do you really want to delete this position?"/>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
          <v-btn color="primary darken-1" flat @click.native="deleteInquiryPosition(editInquiryPositionData)">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Batch Edit - Dialog-->
    <v-dialog v-model="batchEditDialog" max-width="800px">
      <v-card>

        <v-card-title>
          <span class="headline">Batch Edit</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12 md8 pl-4 pa-2>
                <v-autocomplete
                  clearable
                  :items="batchEditModes"
                  label="Edit Mode"
                  v-model="selectedBatchEditMode"
                  item-value="id"
                  item-text="name"
                />
              </v-flex>


              <!--               <v-flex sm12 md6 pl-4 pa-2 >
                               <v-text-field
                                 label="Quantity"
                                 v-model="getSelectedOfferPosition.quantity"
                                 type="number"
                                 min="1"
                               />
                             </v-flex>-->

              <v-flex sm12 md6 pl-4 pa-2 v-show="selectedBatchEditMode === 1">
                <v-text-field
                  suffix="%"
                  label="Margin"
                  v-model="selectedBatchEditValue"
                  type="number"
                  step=".01"
                  min="0.01"
                  max="1"
                />
              </v-flex>


            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" flat @click.native="closeBatchEditDialog">Cancel</v-btn>
          <v-btn :loading="batchUpdateLoading" color="primary darken-1" flat @click.native="saveBatchEdit()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap>

      <v-flex xs12 sm12 pr-4 pt-4 pl-4>

        <v-btn class="secondary white--text" @click.native="openNewPositionDialog()">
          New Offer Position
          <v-icon class="white--text" right>add</v-icon>
        </v-btn>

        <v-btn class="secondary white--text" @click.native="openBatchEditDialog()"
               v-show="batchEditSelected.length > 0">
          Batch Edit
          <v-icon class="white--text" right>edit</v-icon>
        </v-btn>

      </v-flex>

    </v-layout>

    <v-layout id="table-container" row>
      <v-flex xs12 pr-4 pt-4 pl-4>
        <v-card>
          <v-card-title>
            Offer Positions
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            />
          </v-card-title>

          <v-data-table
            v-model="batchEditSelected"
            :headers="headers"
            :items="getItems"
            :pagination.sync="pagination"
            :total-items=total
            class="elevation-0 offer-table"
            select-all
            :loading="loading"
            :rows-per-page-items="rowsPageItems"
          >

            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                <span>
                                          {{ props.header.text }}
                                        </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <tr @dblclick="openCalculateDialog(props.item.id)" :active="props.selected"
                  @click="props.selected = !props.selected">
                <td>
                  <v-checkbox
                    :input-value="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td>{{ props.item.id }}</td>
                <td class="text-xs-left">{{ props.item.product.manufacturer.name }}</td>
                <td class="text-xs-left">{{ props.item.product.reference }}</td>
                <td class="text-xs-left">{{ props.item.quantity }}</td>
                <td class="text-xs-left">{{ props.item.unit.code }}</td>
                <td class="text-xs-right">
                  {{exchangedSupplierOfferUnitPrice(getPropertyByPath(props.item, 'supplier_offer_position', null)) |
                  toMoney }} {{getSelectedOffer.currency.name}}
                </td>
                <td class="text-xs-right">{{props.item.margin | toMoney }}</td>
                <td class="text-xs-right">{{props.item.unit_sales_price | toMoney }}
                  {{props.item.customers_offer.currency.name}}
                </td>
                <td class="text-xs-right">{{props.item.total_sales_price | toMoney }}
                  {{props.item.customers_offer.currency.name}}
                </td>
                <td class="text-xs-left">{{props.item.vat.name }}</td>
                <td class="text-xs-left">{{ props.item.customers_offers_positions_status.name }}</td>
                <td class="text-xs-right">

                  <v-icon size="20" color="secondary"
                          class="ma-1"
                          @click="openCalculateDialog(props.item.id)"
                  >
                    fa-calculator
                  </v-icon>

                  <v-icon color="primary"
                          class="ma-1"
                          @click="openNewPositionDialog(props.item.id)"
                  >
                    edit
                  </v-icon>

                  <v-icon color="red"
                          class="ma-1"
                          @click="deletePositionDialog(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>

        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-end mr-5>

      <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>

        <v-btn :loading="getCreatingOfferForInquiry" class="secondary white--text"
               @click.native="createCustomerOffer()">
          Create Customer Offer
        </v-btn>

      </v-flex>

    </v-layout>
    <!--CalculateDialog-->
    <calculateDialog v-if="renderCalculateDialog"/>

  </div>
</template>

<script>
  import {
    Settings,
    Offer,
    OfferPosition,
    ManufacturersSettings,
    ProductSettings,
    VatSettings
  } from '../../../store/namespace-helper'

  import calculateDialog from './CalculateOfferPositionDialog.vue'
  import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'
  import {numberFormatFilters} from '../../../mixins/numberFormatFilters'
  import {propertyHelperMixin} from '../../../mixins/propertyHelperMixin'

  import {in$, $} from 'moneysafe'
  import {$$, subtractPercent, addPercent} from 'moneysafe/ledger'

  import _ from 'lodash'

  export default {
    name: 'OfferPositions',
    mixins: [comboAutoCompleteFiltersMixin, numberFormatFilters, propertyHelperMixin],
    components: {
      calculateDialog
    },
    data () {
      return {
        isVisible: false,
        hide: true,
        activeTab: 0,
        headers: [
          {text: 'Position-ID', value: 'id'},
          {text: 'Manufacturer', value: 'manufacturers_id'},
          {text: 'Reference', value: 'reference'},
          {text: 'Quantity', value: 'quantity'},
          {text: 'Unit', value: 'unit_id', sortable: false},
          {text: 'Unit Purchase Price', value: 'unit_price', sortable: false, align: 'right'},
          {text: 'Margin', value: 'margin', sortable: false, align: 'right'},
          {text: 'Unit Sales Price', value: 'unit_sales_price', sortable: false, align: 'right'},
          {text: 'Total Sales Price', value: 'total_sales_price', sortable: false, align: 'right'},
          {text: 'Tax/Vat', value: 'vats_id', sortable: false},
          {text: 'Status', value: 'inquiries_position_status_id'},
          {text: 'Actions', value: '', sortable: false, align: 'right'}
        ],
        pagination: {},
        search: '',
        total: 0,
        onDismissed: false,
        rowsPageItems: [{'text': 'All', 'value': -1}],
        selectedSuppliers: null,
        chipsDeletable: true,
        addDialog: false,
        batchEditDialog: false,
        deleteDialog: false,
        deleteChecked: false,
        deleteFormValidation: false,
        rules: {
          required: value => !!value || 'Required.',
          descriptionCounter: value => value.length <= 500 || 'Max 500 characters',
          numberCounter: value => value.length <= 255 || 'Max 255 characters'
        },
        creatingRequestsErrorMsg: '',
        squareFlag: false,
        creatingOffer: false,
        renderCalculateDialog: false,
        batchEditSelected: [],
        selectedBatchEditMode: null,
        selectedBatchEditValue: null,
        batchEditModes: [
          {
            id: 1,
            name: 'Margin'
          }
/*          {
            id: 2,
            name: 'Discount'
          } */
        ],
        batchUpdateLoading: false

      }
    },
    mounted () {

    },
    methods: {
      visibilityChanged (isVisible, entry) {
        if (this.isVisible !== isVisible) {
          this.isVisible = isVisible
          if (isVisible) {
            console.log('tab visible, load data')
            this.loadItems()
            this.loadManufacturers()
            this.loadUnits()
            this.loadProducts()
            this.loadVats()
            this.loadCurrencyExchangeRate()
          } else {

          }
        }
      },
      loadItems: function () {
        const {sortBy, descending, page, rowsPerPage} = this.pagination
        const query = {
          id: this.getSelectedOffer.id,
          sortBy: sortBy || 'id',
          descending: descending ? 'desc' : 'asc',
          page: page || 1,
          limit: rowsPerPage !== -1 ? rowsPerPage : 0,
          search: this.search ? this.search : ''
        }
        this.$store.dispatch(OfferPosition.actions.loadOffersPositions, query)
      },
      loadManufacturers () {
        this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
      },
      loadUnits () {
        this.$store.dispatch(Settings.actions.loadAllUnits)
      },
      loadSuppliers (manufacturersId) {
        console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
        this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
      },
      loadProducts () {
        this.$store.dispatch(ProductSettings.actions.loadAllProducts)
      },
      loadVats () {
        this.$store.dispatch(VatSettings.actions.loadAllVats)
      },
      openNewPositionDialog (val) {
        let item = this.getItems.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, item)
        }
        this.addDialog = true
      },
      getManufacturerName (val) {
        let item = this.getProducts.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          if (item.manufacturer !== null && typeof item.manufacturer !== 'undefined') {
            return item.manufacturer.name
          }
        }
        return ''
      },
      savePosition () {
        console.log('saveNewOfferPosition: ' + JSON.stringify(this.getSelectedOfferPosition))
        console.log('getSelectedOffer: ' + JSON.stringify(this.getSelectedOffer))

        // this.getSelectedOfferPosition.customers_offers_id = this.getSelectedOffer.id

        let saveCustomerOfferPosition = {
          id: this.getSelectedOfferPosition.id,
          vats_id: this.getSelectedOfferPosition.vats_id,
          margin: this.getSelectedOfferPosition.margin,
          units_id: this.getSelectedOfferPosition.units_id,
          products_id: this.getSelectedOfferPosition.products_id,
          quantity: this.getSelectedOfferPosition.quantity,
          customers_offers_id: this.getSelectedOffer.id
        }

        this.$store.dispatch(OfferPosition.actions.saveOfferPosition, saveCustomerOfferPosition).then(response => {
          this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, null)
          this.loadItems()
        })

        this.addDialog = false
      },
      closeAddEditPositionDialog () {
        this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, null)
        this.addDialog = false
      },
      createCustomerOffer () {
        this.$store.dispatch(Offer.actions.createCustomerOfferMessage, this.getSelectedOffer.id).then(response => {
          this.creatingOffer = true
          this.$echo.private('customer-offer-created-chan.' + this.getSelectedOffer.id).listen('CustomerOfferCreated', (payload) => {
            console.log('message sent event: ' + JSON.stringify(payload))
            this.$store.dispatch(Offer.actions.reloadSelectedCustomerOffer, this.getSelectedOffer.id).then(response => {
              this.$echo.leave('customer-offer-created-chan.' + this.getSelectedOffer.id)
            })
            this.creatingOffer = false
          })
        })
      },
      deleteInquiryPosition (item) {
        if (!this.$refs.form.validate()) {
          return
        }

        this.deleteDialog = false
        this.deleteChecked = false

        /*          const {sortBy, descending, page, rowsPerPage} = this.pagination */
        /*          const requestData = {
                    id: this.getSelectedInquiry.id,
                    sortBy: sortBy || 'id',
                    descending: descending ? 'desc' : 'asc',
                    page: page || 1,
                    limit: rowsPerPage !== -1 ? rowsPerPage : 0,
                    search: this.search ? this.search : '',
                    inquiryPosition: item
                  } */

        /*          this.$store.dispatch(OfferPosition.actions.deleteInquiriesPositions, requestData) */
      },
      deletePositionDialog (item) {
        this.editInquiryPositionData = _.cloneDeep(item)
        this.deleteDialog = true
      },
      cancelDeleteDialog () {
        this.deleteDialog = false
        this.$refs.form.reset()
      },
      openCalculateDialog (val) {
        let item = this.getItems.find(x => x.id === val)
        if (item !== null && typeof item !== 'undefined') {
          this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, item)
        }
        this.renderCalculateDialog = true
        setTimeout(() => {
          this.$store.dispatch(OfferPosition.actions.openCloseCalculateDialog)
        }, 200)
      },
      throttledLoadItems: _.debounce(function () {
        this.loadItems()
      }, 450),
      throttledTranslate: _.debounce(function (q, target) {
        this.translate(q, target)
      }, 450),
      closeBatchEditDialog () {
        this.batchEditDialog = false
      },
      openBatchEditDialog () {
        this.batchEditDialog = true
      },
      saveBatchEdit () {
        this.batchUpdateLoading = true
        let positionsToUpdate = []
        this.batchEditSelected.forEach(item => {
          if (item.supplier_offer_position) {
            switch (this.selectedBatchEditMode) {
              case 1:
                item.margin = this.selectedBatchEditValue

                let unitPrice = 0

                if (this.needExchange(item.supplier_offer_position)) {
                  unitPrice = in$(($(this.calculateSupplierOfferUnitPriceMethod(item.supplier_offer_position)) / item.margin) / this.getExchangeRate(item.supplier_offer_position))
                } else {
                  unitPrice = in$($(this.calculateSupplierOfferUnitPriceMethod(item.supplier_offer_position)) / item.margin)
                }

                item.customers_offers_positions_additional_costs.forEach(function (item) {
                  if (item.type === 'fixed') {
                    unitPrice = $$(
                      $(unitPrice),
                      $(item.value)
                    ).$
                  } else {
                    unitPrice = $$(
                      $(unitPrice),
                      addPercent(item.value)
                    ).$
                  }
                })
                item.customers_offers_positions_commissions.forEach(function (item) {
                  unitPrice = $$(
                    $(unitPrice),
                    addPercent(item.value)
                  ).$
                })
                item.customers_offers_positions_discounts.forEach(function (item) {
                  unitPrice = $$(
                    $(unitPrice),
                    subtractPercent(item.value)
                  ).$
                })

                item.unit_sales_price = unitPrice
                item.total_sales_price = item.unit_sales_price * item.quantity

                positionsToUpdate.push({
                  id: item.id,
                  margin: item.margin,
                  unit_sales_price: item.unit_sales_price,
                  total_sales_price: item.total_sales_price
                })

                break
              case 2:
            }
          } else {
            this.batchEditSelected.splice(this.batchEditSelected.findIndex(x => x.id === item.id), 1)
          }
        })

        this.$store.dispatch(OfferPosition.actions.saveOfferPositions, {
          customer_offer_positions: positionsToUpdate
        }).then(response => {
          this.loadItems()
          this.batchUpdateLoading = false
          this.batchEditDialog = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.batchUpdateLoading = false
          this.batchEditDialog = false
        })
      },
      needExchange (supplierOfferPosition) {
        if (this.getSelectedOffer.currency.id !== supplierOfferPosition.suppliers_offer.currency.id) {
          return true
        } else {
          return false
        }
      },
      getExchangeRate (supplierOfferPosition) {
        if (this.getSelectedOffer.currency.name) {
          let currency = supplierOfferPosition.suppliers_offer.currency.name
          return this.$store.getters[Settings.getters.getExchangeRate].quotes['USD' + currency]
        }
        return 0.00
      },
      loadCurrencyExchangeRate () {
        this.$store.dispatch(Settings.actions.loadExchangeRate, this.getSelectedOffer.currency.name)
      },
      calculateSupplierOfferUnitPriceMethod (val) {
        if (val.discounts) {
          let unitPrice = val.unit_price
          val.discounts.forEach(function (item) {
            unitPrice = $$(
              $(unitPrice),
              subtractPercent(item.value)
            ).$
          })
          return unitPrice
        }
        return null
      },
      exchangedSupplierOfferUnitPrice (supplierOfferPosition) {
        if (
          supplierOfferPosition &&
          supplierOfferPosition.suppliers_offer &&
          supplierOfferPosition.suppliers_offer.currency &&
          supplierOfferPosition.suppliers_offer.currency.name) {
          if (this.needExchange(supplierOfferPosition)) {
            return this.calculateSupplierOfferUnitPriceMethod(supplierOfferPosition) / this.getExchangeRate(supplierOfferPosition)
          } else {
            return this.calculateSupplierOfferUnitPriceMethod(supplierOfferPosition)
          }
        }
        return '-'
      }

    },
    computed: {
      getItems () {
        this.total = this.$store.getters[OfferPosition.getters.offersPositions].length
        return this.$store.getters[OfferPosition.getters.offersPositions]
      },
      getSuppliers () {
        return this.$store.getters[Settings.getters.getManufacturerSuppliers]
      },
      getSelectedOffer () {
        return this.$store.getters[Offer.getters.getSelectedOffer]
      },
      getCreatingOfferForInquiry () {
        return this.$store.getters[Offer.getters.getCreatingOfferForInquiry]
      },
      getSelectedOfferPosition () {
        return this.$store.getters[OfferPosition.getters.getSelectedOfferPosition]
      },
      getManufacturers () {
        return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
      },
      getProducts () {
        return this.$store.getters[ProductSettings.getters.getAllProducts]
      },
      getVats () {
        return this.$store.getters[VatSettings.getters.getAllVats]
      },
      getUnits () {
        return this.$store.getters[Settings.getters.getAllUnits]
      },
      loading () {
        return this.$store.getters[Settings.getters.loading]
      },
      descriptionRules () {
        return [this.rules.descriptionCounter]
      },
      numberRules () {
        return [this.rules.numberCounter]
      },
      calculateDialogState () {
        return this.$store.getters[OfferPosition.getters.getOpenCalculateDialogState]
      }

    },
    watch: {
      pagination: {
        handler () {
          this.loadItems()
        },
        deep: true
      },
      calculateDialogState: {
        handler (val) {
          if (!val) {
            setTimeout(() => {
              this.renderCalculateDialog = false
            }, 850)
            this.loadCurrencyExchangeRate()
            this.loadItems()
          }
        },
        deep: true
      },
      search: {
        handler (val) {
          this.throttledLoadItems()
        },
        deep: true
      }
    }

  }
</script>

<style scoped>

  th:focus {
    outline: none !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/Offers/OfferPositions/OfferPositions.vue